import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const styles = tv({
    slots: {
        container: `
      iris:group
      iris:w-fit
      iris:cursor-pointer
      iris:rounded-(--comp-size-radius-input)
      iris:duration-(--comp-motion-duration-check-radio)
      iris:ease-(--comp-motion-easing-check-radio)
      iris:data-[state=disabled]:cursor-not-allowed
      iris:data-[state=disabled]:opacity-(--sem-opacity-interactive-disabled)
    `,
        gapContainer: `
      iris:flex
      iris:items-start
      iris:gap-(--comp-space-gap-check-radio)
    `,
        checkboxWrapper: `
      iris:peer
      iris:flex
      iris:size-(--comp-size-box-check-radio-control)
      iris:items-center
      iris:self-start
    `,
        indicator: `
      iris:relative 
      iris:h-full
      iris:w-full
      iris:text-(--comp-color-content-check-radio-control-selected)
      iris:[&_svg]:block
      iris:[&_svg]:align-middle
    `,
        checkbox: `
      iris:border-(length:--comp-size-border-check-radio-control)
      iris:transition-all
      iris:duration-(--comp-motion-duration-check-radio)
      iris:ease-(--comp-motion-easing-check-radio)
    `,
        label: `
      iris:min-h-(--base-space-px-24)
      iris:cursor-pointer
      iris:font-(family-name:--comp-type-font-check-radio-label)
      iris:text-(length:--comp-type-size-check-radio-label)
      iris:leading-(--comp-type-leading-check-radio-label)
      iris:font-(--comp-type-weight-check-radio-label)!
      iris:text-(--comp-color-content-check-radio-label-rest)
      iris:group-disabled:cursor-not-allowed
    `,
    },
    variants: {
        inverse: {
            false: {
                checkbox: `
        iris:group-data--[state=checked]:bg-(--comp-color-background-check-radio-control-selected)
        iris:group-hover:bg-(--comp-color-background-check-radio-control-hover)
        iris:group-data-[state=checked]:border-(--comp-color-border-check-radio-control-selected)
        iris:group-data-[state=disabled]:group-hover:border-(--comp-color-border-check-radio-control-rest)
      `,
                label: `iris:group-data-[state=checked]:text-(--comp-color-content-check-radio-label-selected)
          iris:group-data-[state=disabled]:group-hover:text-(--comp-color-content-check-radio-label-rest)
          `,
                container: focusStyles.default,
            },
            true: {
                checkbox: `
        iris:group-data-[state=checked]:border-(--comp-color-border-check-radio-control-inverse-selected)
        iris:group-data-[state=checked]:bg-(--comp-color-background-check-radio-control-inverse-selected)
        iris:group-data-[state=disabled]:group-hover:border-(--comp-color-border-check-radio-control-inverse-rest)
        `,
                label: `iris:group-data-[state=checked]:text-(--comp-color-content-check-radio-label-inverse-selected)
                iris:group-data-[state=disabled]:group-hover:text-(--comp-color-content-check-radio-label-inverse-rest)
                    `,
                container: focusStyles.inverse,
                indicator: "iris:text-(--comp-color-content-check-radio-control-inverse-selected)",
            },
        },
        error: {
            true: "",
        },
        hasLabel: {
            true: {
                checkboxWrapper: "iris:min-h-(--base-space-px-24)",
            },
        },
    },
    compoundVariants: [
        {
            inverse: false,
            error: false,
            class: {
                label: "iris:group-hover:text-(--comp-color-content-check-radio-label-hover)",
                checkbox: "iris:group-hover:border-(--comp-color-border-check-radio-control-hover)",
            },
        },
        {
            inverse: true,
            error: false,
            class: {
                label: `
          iris:text-(--comp-color-content-check-radio-label-inverse-rest)
          iris:group-hover:text-(--comp-color-content-check-radio-label-inverse-hover)
          iris:peer-hover:text-(--comp-color-content-check-radio-label-inverse-hover)
        `,
                checkbox: `iris:group-hover:border-(--comp-color-border-check-radio-control-inverse-hover)
        iris:group-hover:bg-(--comp-color-background-check-radio-control-inverse-hover)
        `,
            },
        },
        {
            inverse: false,
            error: true,
            class: {
                checkbox: `
          iris:hover:border-(--comp-color-border-check-radio-control-error),
          iris:border-(--comp-color-border-check-radio-control-error)
          iris:bg-(--comp-color-background-check-radio-control-error)
          iris:group-hover:border-(--comp-color-border-check-radio-control-error)
          iris:group-hover:bg-(--comp-color-background-check-radio-control-error)
          iris:group-data-[state=disabled]:group-hover:border-(--comp-color-border-check-radio-control-error)
          iris:hover:bg-(--comp-color-background-check-radio-control-error)`,
                label: `
          iris:text-(--comp-color-content-check-radio-label-error)
          iris:group-data-[state=checked]:text-(--comp-color-content-check-radio-label-error)
          iris:group-data-[state=disabled]:group-hover:text-(--comp-color-content-check-radio-label-error)
          iris:hover:text-(--comp-color-content-check-radio-label-error)`,
            },
        },
        {
            inverse: true,
            error: true,
            class: {
                checkbox: `
          iris:border-(--comp-color-border-check-radio-control-inverse-error)
          iris:bg-(--comp-color-background-check-radio-control-inverse-error)
          iris:group-hover:border-(--comp-color-border-check-radio-control-inverse-error)
          iris:group-hover:bg-(--comp-color-background-check-radio-control-inverse-error)
          iris:group-data-[state=disabled]:group-hover:border-(--comp-color-border-check-radio-control-inverse-error)
          iris:hover:border-(--comp-color-border-check-radio-control-inverse-error)
          iris:hover:bg-(--comp-color-background-check-radio-control-inverse-error)

        `,
                label: `
          iris:text-(--comp-color-content-check-radio-label-inverse-error)
          iris:group-data-[state=checked]:text-(--comp-color-content-check-radio-label-inverse-error)
          iris:group-data-[state=disabled]:group-hover:text-(--comp-color-content-check-radio-label-inverse-error)
          iris:hover:text-(--comp-color-content-check-radio-label-inverse-error)
        `,
            },
        },
    ],
});

export { styles as default };
